<!--
Non-Bootstrap modal popup. Aims to be a drop-in replacement for ModalPopup.vue
-->
<template>
  <transition name="modal">
      <div class="modal-mask" :id="id">
          <div 
            :class="displayAt == 'top' ? 'modal-wrapper-top' : 'modal-wrapper'">
          <div class="modal-container">

              <div v-if="!hideTitleBar" class="modal-header">
              <div class="title">{{ title }}
                  <button 
                    v-if="showX" 
                    class="closeBtn"
                    @click="close()"
                    aria-label="Close"
                  >
                      <font-awesome-icon icon="x" size="lg" class="bookingItemIcon"></font-awesome-icon>
                  </button>
              </div>
          </div>

          <div class="modal-body">
              <slot></slot>
          </div>

          </div>
      </div>
  </div>
  </transition>

</template>

<script>
export default {
name: 'NewModalPopup',
props: [ 'id', 'title', 'hideTitleBar', 'showX', 'displayAt' ],
methods: {
  close () {
    this.$emit('close')
  }
},

}
</script>
<style lang="scss" scoped>

div.title {
  display: block;
  width: 100%;
}
.closeBtn {
  float: right;
  cursor: pointer;
  padding: 0px;
  border: none;
  background: transparent;
}
/* lifted from https://v2.vuejs.org/v2/examples/modal.html */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.5s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-wrapper-top {
  display: table-cell;
  vertical-align: top;
}

.modal-container {
  width: 80%;
  margin: 0px auto;
  padding: 1px 1px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  margin-top: 0;
  font-weight: 700;
  color: #ffffff;
  background-color: #003865;
  padding: 15px;
}

.modal-default-button {
  float: right;
}

.modal-body {
  padding: 20px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
